import { render } from "./CreateFoodOrdersStep2Model.vue?vue&type=template&id=22f91518"
import script from "./CreateFoodOrdersStep2Model.vue?vue&type=script&lang=js"
export * from "./CreateFoodOrdersStep2Model.vue?vue&type=script&lang=js"

import "./CreateFoodOrdersStep2Model.vue?vue&type=style&index=0&id=22f91518&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__